import styled from "@emotion/styled";

export const ApproveTokenTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
